import { render, staticRenderFns } from "./GestionCostoExclusivo.vue?vue&type=template&id=9a9c6bf2&scoped=true"
import script from "./GestionCostoExclusivo.vue?vue&type=script&lang=js"
export * from "./GestionCostoExclusivo.vue?vue&type=script&lang=js"
import style0 from "./GestionCostoExclusivo.vue?vue&type=style&index=0&id=9a9c6bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9c6bf2",
  null
  
)

export default component.exports